import React from 'react';
import { Input } from '../../../components/ui/input';

export const FRACTIONS = [
  { v: 0, label: '—' }, { v: 0.125, label: '⅛' }, { v: 0.25, label: '¼' }, { v: 0.375, label: '⅜' },
  { v: 0.5, label: '½' }, { v: 0.625, label: '⅝' }, { v: 0.75, label: '¾' }, { v: 0.875, label: '⅞' },
];

// 35.5 → '35 ½' (arredonda ao 1/8 mais próximo)
export const fmtInches = (v) => {
  if (v === null || v === undefined || v === '' || Number.isNaN(Number(v))) return '—';
  const val = Number(v);
  let whole = Math.floor(val);
  let eighths = Math.round((val - whole) * 8);
  if (eighths === 8) { whole += 1; eighths = 0; }
  const f = FRACTIONS.find((x) => Math.round(x.v * 8) === eighths);
  if (!eighths) return String(whole);
  return whole ? `${whole} ${f.label}` : f.label;
};

const split = (v) => {
  const val = Number(v) || 0;
  let whole = Math.floor(val);
  let eighths = Math.round((val - whole) * 8);
  if (eighths === 8) { whole += 1; eighths = 0; }
  return { whole, frac: eighths / 8 };
};

// Polegadas inteiras + fração (⅛ … ⅞). onChange recebe o decimal.
export const InchesInput = ({ value, onChange, testId, className = '' }) => {
  const { whole, frac } = split(value);
  const wholeStr = value === '' || value === null || value === undefined ? '' : String(whole);
  return (
    <div className={`flex gap-1.5 ${className}`} data-testid={testId}>
      <Input
        type="number" inputMode="numeric" min="0" step="1" value={wholeStr} placeholder="0"
        onChange={(e) => { const w = e.target.value; onChange(w === '' ? '' : (parseInt(w, 10) || 0) + frac); }}
        className="h-11 font-mono flex-1 min-w-0" data-testid={testId ? `${testId}-whole` : undefined}
      />
      <select
        value={String(frac)} onChange={(e) => onChange((wholeStr === '' ? 0 : whole) + Number(e.target.value))}
        className="h-11 w-16 rounded-2xl border border-slate-300/90 bg-white/80 px-1 text-base font-semibold text-center focus:outline-none focus:ring-4 focus:ring-teal-500/20 focus:border-teal-600"
        aria-label="fraction" data-testid={testId ? `${testId}-frac` : undefined}
      >
        {FRACTIONS.map((f) => <option key={f.v} value={String(f.v)}>{f.label}</option>)}
      </select>
    </div>
  );
};
